import get from "lodash/get";

import {
  CLEAR_DETAILED_CYPRESS_COMMAND_LOGS,
  FETCH_DETAILED_CYPRESS_COMMAND_LOGS_FAILED,
  FETCH_DETAILED_CYPRESS_COMMAND_LOGS_LOADING,
  FETCH_DETAILED_CYPRESS_COMMAND_LOGS_SUCCESS
} from "../actionTypeConstants/DetailedCypressCommandLogs";

import { transformDetailedCypressLogs } from "../../utility/transformer/detailedCypressCommandLogs";

const initialState = {
  logs: [],
  loading: true,
  error: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_DETAILED_CYPRESS_COMMAND_LOGS_LOADING: {
      return {
        ...state,
        loading: true,
        logs: [],
        error: null
      };
    }

    case FETCH_DETAILED_CYPRESS_COMMAND_LOGS_SUCCESS: {
      const { isFetchFromLTMA = false } = action.payload;
      const payload = isFetchFromLTMA
        ? transformDetailedCypressLogs(get(action, ["result", "data"], ""))
        : transformDetailedCypressLogs(
            get(action, ["result", "data", "data"], "")
          );
      return {
        ...state,
        loading: false,
        logs: payload,
        error: null
      };
    }

    case FETCH_DETAILED_CYPRESS_COMMAND_LOGS_FAILED: {
      return {
        ...state,
        loading: false,
        logs: [],
        error: action.error.response
      };
    }

    case CLEAR_DETAILED_CYPRESS_COMMAND_LOGS: {
      return {
        ...state,
        loading: false,
        logs: [],
        error: null
      };
    }

    default: {
      return state;
    }
  }
}
